import React from 'react'
import Link from 'gatsby-link'
import styles from './index.module.css'
import './index.css'

const MenuDesk = () => (
  <nav className={styles.wrapper}>
    <ul className={styles.list}>
      <Link className="item" activeClassName={'current'} to="/editorial/">
        Editorial
      </Link>
      <Link className="item" activeClassName={'current'} to="/portrait/">
        Portrait
      </Link>
      <Link className="item" activeClassName={'current'} to="/travel/">
        Travel
      </Link>
      <Link className="item" activeClassName={'current'} to="/freiearbeit/">
        freie Arbeit
      </Link>
      <Link className="item" activeClassName={'current'} to="/reportage/">
        Reportage
      </Link>
      <Link className="item" activeClassName={'current'} to="/wedding/">
        Wedding
      </Link>
      <span className="line" />
    </ul>
  </nav>
)

export default MenuDesk



// WEBPACK FOOTER //
// ./src/components/MenuDesk/index.js